<template>
    <main class="adminLayout">
      <Alerts :success="isSuccess" :error="error" />
      <!-- 'container-max-width': isContained, -->
      <!-- class="default-sidebar-width" -->
      <div class="container mx-auto px-4 lg:px-4 bg-white rounded-lg">
        <slot name="default"></slot>
      </div>
    </main>
</template>
<script>
import { Alerts } from "@/components/t-components";
import { mapGetters } from "vuex";
export default {
    components: {
        Alerts
    },
    computed: {
      ...mapGetters([
        "isSuccess",
        "error"
      ])
    }
}
</script>